import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import MeuPerfil from './pages/MeuPerfil';
import MeuMix from './pages/MeuMix';
import ProdutoMix from './pages/ProdutoMix';
import Vendas from './pages/Vendas';
import Pedidos from './pages/Pedidos';
import Cotacoes from './pages/Cotacoes';
import CotacaoDetalhe from './pages/CotacaoDetalhe';
import Fornecedores from './pages/admin/Fornecedores';
import Usuarios from './pages/admin/Usuarios';
import Ajuda from './pages/admin/Ajuda';

// Faixa do "Ver como": deixa claro que é a visão de outra pessoa e leva de volta pra conta do admin.
function FaixaVerComo() {
  const { user, visualizando, voltarDoVerComo } = useAuth();
  if (!visualizando) return null;
  const empresas = (user.fornecedores || []).map((f) => f.nome).join(', ');
  return (
    <div className="faixa-ver-como" role="status">
      <i className="bi bi-eye-fill" />
      <span className="faixa-txt">
        Vendo como <b>{user.nome || user.username}</b>
        {empresas ? <span className="faixa-empresas"> ({empresas})</span> : null} — só visualização
      </span>
      <button type="button" onClick={voltarDoVerComo}>Voltar pra minha conta</button>
    </div>
  );
}

function AppLayout() {
  return (
    <div className="layout">
      <FaixaVerComo />
      <Sidebar />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

// Rota privada + trava de senha provisória (fornecedor precisa trocar antes de usar)
function PrivateRoute() {
  const { user } = useAuth();
  const loc = useLocation();
  // guarda o endereço pedido (ex.: o link da cotação no e-mail) pra voltar nele depois do login
  if (!user) return <Navigate to="/login" replace state={{ de: loc.pathname }} />;
  if (user.tipo === 'fornecedor' && user.senha_provisoria && loc.pathname !== '/meu-perfil') {
    return <Navigate to="/meu-perfil" replace />;
  }
  return <AppLayout />;
}

function Home() {
  const { ehInterno } = useAuth();
  return <Navigate to={ehInterno ? '/admin/fornecedores' : '/meu-mix'} replace />;
}

export default function App() {
  const { user } = useAuth();
  const loc = useLocation();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={loc.state?.de || '/'} replace /> : <Login />} />

      <Route element={<PrivateRoute />}>
        <Route path="/" element={<Home />} />
        {/* Fornecedor */}
        <Route path="/meu-mix" element={<MeuMix />} />
        <Route path="/meu-mix/:codpro" element={<ProdutoMix />} />
        <Route path="/vendas" element={<Vendas />} />
        <Route path="/pedidos" element={<Pedidos />} />
        <Route path="/cotacoes" element={<Cotacoes />} />
        <Route path="/cotacoes/:id" element={<CotacaoDetalhe />} />
        {/* Administração (interno) */}
        <Route path="/admin/fornecedores" element={<Fornecedores />} />
        <Route path="/admin/usuarios/:fornecedorId" element={<Usuarios />} />
        <Route path="/admin/ajuda" element={<Ajuda />} />
        {/* Conta */}
        <Route path="/meu-perfil" element={<MeuPerfil />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
